module.exports = __webpack_public_path__ + "img/FDB-demo.72ea5468.png";